module.exports = __webpack_public_path__ + "img/instruction_4.9a1f049d.svg";